(function () {
  var form = document.querySelector('[data-sticker-form]');
  if (!form) return;

  var variantsScript = form.querySelector('[data-product-variants]');
  var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
  var variantIdInput = form.querySelector('[data-sticker-variant-id]');
  var quantityValueInput = form.querySelector('[data-sticker-quantity-value]');
  var submitBtn = form.querySelector('[data-add-to-cart]');
  var submitText = form.querySelector('[data-add-to-cart-text]');
  var priceEl = form.closest('.product-info').querySelector('.product-info__price');

  var selectedSize = null;
  var selectedQty = null;
  var initialSizeBtn = form.querySelector('[data-size-value].is-selected');
  var initialQtyBtn = form.querySelector('[data-qty-value].is-selected');
  if (initialSizeBtn) selectedSize = initialSizeBtn.getAttribute('data-size-value');
  if (initialQtyBtn) selectedQty = initialQtyBtn.getAttribute('data-qty-value');
  if (!selectedSize || !selectedQty) {
    var firstVariant = variants[0];
    if (firstVariant) {
      selectedSize = selectedSize || firstVariant.option1;
      selectedQty = selectedQty || firstVariant.option2;
    }
  }

  function findVariant(size, qty) {
    return variants.find(function (v) { return v.option1 === size && v.option2 === qty; });
  }

  /* Custom sizing: rather than showing a made-up estimate, we auto-match the
     customer's exact dimensions to the smallest real "Custom (up to W x H)"
     Size variant that fits (checked in both orientations). That variant has
     a real merchant-set price in Shopify, so what's shown here is always
     exactly what gets charged at checkout — no synthetic pricing. */
  function parseSize(sizeStr) {
    var m = /([\d.]+)"\s*x\s*([\d.]+)"/i.exec(sizeStr || '');
    if (!m) return null;
    var w = parseFloat(m[1]);
    var h = parseFloat(m[2]);
    return { w: w, h: h, area: w * h };
  }

  function getCustomBrackets() {
    var seen = {};
    var out = [];
    variants.forEach(function (v) {
      if (!/^Custom \(up to/i.test(v.option1)) return;
      if (seen[v.option1]) return;
      seen[v.option1] = true;
      var s = parseSize(v.option1);
      if (s) out.push({ size: v.option1, w: s.w, h: s.h, area: s.area });
    });
    out.sort(function (a, b) { return a.area - b.area; });
    return out;
  }

  function matchCustomBracket(width, height) {
    if (!width || !height) return null;
    var brackets = getCustomBrackets();
    for (var i = 0; i < brackets.length; i++) {
      var b = brackets[i];
      var fits = (width <= b.w && height <= b.h) || (width <= b.h && height <= b.w);
      if (fits) return b.size;
    }
    return null;
  }

  function summaryEls() {
    return {
      quantity: form.closest('.product-info').querySelector('[data-sticker-summary-quantity]'),
      unitPrice: form.closest('.product-info').querySelector('[data-sticker-summary-unit-price]'),
      total: form.closest('.product-info').querySelector('[data-sticker-summary-total]')
    };
  }

  function renderPricingTableFor(size, qty) {
    var rowsEl = form.querySelector('[data-pricing-table-rows]');
    if (!rowsEl) return;
    var rows = variants.filter(function (v) { return v.option1 === size; });
    rowsEl.innerHTML = rows.map(function (v) {
      var qtyNum = parseInt(v.option2, 10) || 0;
      var isActive = v.option2 === qty;
      return '<div class="pricing-table__row' + (isActive ? ' is-active' : '') + '">' +
        '<span>' + v.option2 + ' stickers</span>' +
        '<span>' + window.themeFormatMoney(v.price * qtyNum) + ' <em>(' + window.themeFormatMoney(v.price) + ' ea)</em></span>' +
        '</div>';
    }).join('');
  }

  function applyRealVariant(size, qty) {
    var match = findVariant(size, qty);
    if (!match) return;
    if (variantIdInput) variantIdInput.value = match.id;
    if (quantityValueInput) quantityValueInput.value = match.option2;

    var priceHtml = '<span class="price"><span class="price__current">' + window.themeFormatMoney(match.price) + '</span></span>';
    if (priceEl) priceEl.innerHTML = priceHtml;

    var els = summaryEls();
    var qtyNum = parseInt(match.option2, 10) || 0;
    if (els.quantity) els.quantity.textContent = match.option2;
    if (els.unitPrice) els.unitPrice.innerHTML = priceHtml;
    if (els.total) els.total.textContent = window.themeFormatMoney(match.price * qtyNum);

    if (submitBtn) {
      submitBtn.disabled = !match.available;
      if (submitText) submitText.textContent = match.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
    }

    renderPricingTableFor(size, qty);
  }

  function buildQuoteMailto(width, height) {
    var titleEl = document.querySelector('.product-info__title');
    var productTitle = titleEl ? titleEl.textContent.trim() : document.title;
    var subject = 'Custom size quote request: ' + productTitle;
    var body = 'Product: ' + productTitle +
      '\nCustom size: ' + width + '" x ' + height + '"' +
      '\nQuantity: ' + (selectedQty || '') +
      '\n\nThis size is larger than what\'s offered automatically online — please send me pricing.';
    return 'mailto:info@instagarment.com?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  function updateCustomSelection() {
    var widthInput = form.querySelector('[data-custom-width]');
    var heightInput = form.querySelector('[data-custom-height]');
    var noteEl = form.querySelector('[data-size-custom-note]');
    var quoteBtn = form.querySelector('[data-request-quote]');
    var customDimsInput = form.querySelector('[data-custom-dimensions-input]');
    if (!widthInput || !heightInput) return;

    var width = parseFloat(widthInput.value) || 0;
    var height = parseFloat(heightInput.value) || 0;
    var matchedSize = matchCustomBracket(width, height);

    if (!matchedSize) {
      if (noteEl) {
        noteEl.hidden = false;
        noteEl.textContent = (width && height)
          ? 'That size is larger than we offer automatically online. Click "Request a Custom Quote" and we’ll send you pricing.'
          : 'Enter your exact width and height — we’ll automatically match you to the right size and price.';
      }
      if (submitBtn) submitBtn.hidden = true;
      if (quoteBtn) {
        quoteBtn.hidden = !(width && height);
        if (width && height) quoteBtn.href = buildQuoteMailto(width, height);
      }
      if (customDimsInput) { customDimsInput.value = ''; customDimsInput.name = ''; }
      var els = summaryEls();
      if (els.quantity) els.quantity.textContent = selectedQty || '—';
      if (els.unitPrice) els.unitPrice.textContent = '—';
      if (els.total) els.total.textContent = '—';
      var rowsEl = form.querySelector('[data-pricing-table-rows]');
      if (rowsEl) rowsEl.innerHTML = '';
      return;
    }

    if (noteEl) {
      noteEl.hidden = false;
      noteEl.textContent = 'Matched to ' + matchedSize + ' — the smallest size that fits your design, at that size’s price.';
    }
    if (quoteBtn) quoteBtn.hidden = true;
    if (submitBtn) submitBtn.hidden = false;
    if (customDimsInput) {
      customDimsInput.name = 'properties[Custom Dimensions]';
      customDimsInput.value = width + '" x ' + height + '"';
    }

    applyRealVariant(matchedSize, selectedQty);
  }

  function updateSelection() {
    var noteEl = form.querySelector('[data-size-custom-note]');
    var customFieldsEl = form.querySelector('[data-custom-fields]');
    var quoteBtn = form.querySelector('[data-request-quote]');
    var customDimsInput = form.querySelector('[data-custom-dimensions-input]');

    if (selectedSize === 'Custom') {
      if (customFieldsEl) customFieldsEl.hidden = false;
      updateCustomSelection();
      return;
    }

    if (noteEl) noteEl.hidden = true;
    if (customFieldsEl) customFieldsEl.hidden = true;
    if (submitBtn) submitBtn.hidden = false;
    if (quoteBtn) quoteBtn.hidden = true;
    if (customDimsInput) { customDimsInput.value = ''; customDimsInput.name = ''; }

    applyRealVariant(selectedSize, selectedQty);
  }

  form.querySelectorAll('[data-size-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      form.querySelectorAll('[data-size-value]').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      selectedSize = btn.getAttribute('data-size-value');
      var selectedEl = form.querySelector('[data-size-selected]');
      if (selectedEl) selectedEl.textContent = selectedSize === 'Custom' ? 'Custom' : selectedSize;
      updateSelection();
    });
  });

  form.querySelectorAll('[data-qty-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      form.querySelectorAll('[data-qty-value]').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      selectedQty = btn.getAttribute('data-qty-value');
      updateSelection();
    });
  });

  var customWidthInput = form.querySelector('[data-custom-width]');
  var customHeightInput = form.querySelector('[data-custom-height]');
  if (customWidthInput) customWidthInput.addEventListener('input', updateCustomSelection);
  if (customHeightInput) customHeightInput.addEventListener('input', updateCustomSelection);

  var shapeInput = form.querySelector('[data-shape-input]');
  form.querySelectorAll('[data-shape-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      form.querySelectorAll('[data-shape-value]').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      if (shapeInput) shapeInput.value = btn.getAttribute('data-shape-value');
    });
  });

  var pricingToggle = form.querySelector('[data-pricing-toggle]');
  var pricingTable = form.querySelector('[data-pricing-table]');
  if (pricingToggle && pricingTable) {
    pricingToggle.addEventListener('click', function () {
      var isOpen = pricingToggle.getAttribute('aria-expanded') === 'true';
      pricingToggle.setAttribute('aria-expanded', String(!isOpen));
      pricingTable.hidden = isOpen;
      var textEl = pricingToggle.querySelector('[data-pricing-toggle-text]');
      if (textEl) textEl.previousSibling.textContent = isOpen ? 'View pricing list ' : 'Hide pricing list ';
    });
  }

  /* Artwork upload (single required field: Sticker Design) */
  var dropzone = form.querySelector('[data-artwork-dropzone]');
  var fileInput = dropzone ? dropzone.querySelector('[data-artwork-file-input]') : null;

  function setArtworkFile(file) {
    if (!file || !dropzone) return;
    dropzone.querySelector('[data-artwork-file-name]').textContent = file.name;
    dropzone.querySelector('[data-artwork-dropzone-prompt]').hidden = true;
    dropzone.querySelector('[data-artwork-file-row]').hidden = false;
  }

  function resetArtwork() {
    if (!dropzone) return;
    dropzone.querySelector('[data-artwork-dropzone-prompt]').hidden = false;
    dropzone.querySelector('[data-artwork-file-row]').hidden = true;
    fileInput.value = '';
  }

  function validateArtwork() {
    if (!fileInput) return true;
    if (fileInput.files.length === 0) {
      window.alert('Please choose a file to upload for your sticker design.');
      dropzone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
    return true;
  }

  if (dropzone && fileInput) {
    fileInput.addEventListener('change', function () {
      if (fileInput.files[0]) setArtworkFile(fileInput.files[0]);
    });
    ['dragenter', 'dragover'].forEach(function (evt) {
      dropzone.addEventListener(evt, function (e) {
        e.preventDefault();
        dropzone.classList.add('is-dragover');
      });
    });
    ['dragleave', 'drop'].forEach(function (evt) {
      dropzone.addEventListener(evt, function (e) {
        e.preventDefault();
        dropzone.classList.remove('is-dragover');
      });
    });
    dropzone.addEventListener('drop', function (e) {
      var file = e.dataTransfer.files && e.dataTransfer.files[0];
      if (file) {
        fileInput.files = e.dataTransfer.files;
        setArtworkFile(file);
      }
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (selectedSize === 'Custom') {
      var widthInput = form.querySelector('[data-custom-width]');
      var heightInput = form.querySelector('[data-custom-height]');
      var width = widthInput ? parseFloat(widthInput.value) || 0 : 0;
      var height = heightInput ? parseFloat(heightInput.value) || 0 : 0;
      if (!matchCustomBracket(width, height)) return;
    }
    if (!validateArtwork()) return;
    if (!window.themeCart) return;
    submitBtn.classList.add('is-loading');
    submitBtn.disabled = true;
    window.themeCart.add(new FormData(form)).then(function () {
      submitBtn.classList.remove('is-loading');
      submitBtn.disabled = false;
      resetArtwork();
    }).catch(function () {
      submitBtn.classList.remove('is-loading');
      submitBtn.disabled = false;
    });
  });

  updateSelection();
})();
